import { type FC } from 'react';
import {
  UiText,
  UiSimpleGrid,
  UiIconStackSimple
} from '@/lib/ui';
import { generatePageUrl } from '@/app/pages';
import Step from './Step';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { useEventSettingsQuery } from '@/registration/hook/useEventSettingsQuery';

export interface WorkshopTicketsProps {
  isActive?: boolean
}

const WorkshopTickets: FC<WorkshopTicketsProps> = ({
  isActive
}) => {
  const { tenantCode, eventId } = useRegisterRoute();
  const { data: eventSettings } = useEventSettingsQuery(eventId);

  return (
    <Step
      Icon={UiIconStackSimple}
      description={'Workshop tickets'}
      isActive={isActive}
      // isSkipped={!eventSettings?.workshopTicket?.isEnabled}
      // stepNumber={6}
      navLink={generatePageUrl('RegistrationBuildEventWorkshopTickets', { tenantCode, eventId })}
      isSet={eventSettings?.workshopTicket?.isSet}
    >
      <UiSimpleGrid flexGrow={1} columns={2} gap={4}>
        <UiText variant={'body2'} color={'text.secondary'}>{eventSettings?.workshopTicket?.total ?? 0} total</UiText>
      </UiSimpleGrid>
    </Step>
  );
};

export default WorkshopTickets;
